/* src/app/builder-screen-beta/inspector/dropdown-options-modal.component.scss */
.dropdown-options-modal .modal-header {
  margin-bottom: 24px;
}
.dropdown-options-modal .modal-header h3 {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 600;
  color: #262626;
}
.dropdown-options-modal .modal-header .help-text {
  margin: 0;
  font-size: 13px;
  color: #8c8c8c;
  line-height: 1.5;
}
.dropdown-options-modal .modal-content .options-list {
  margin-bottom: 16px;
}
.dropdown-options-modal .modal-content .options-list .options-header {
  display: grid;
  grid-template-columns: 1fr 1fr 60px 48px;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 2px solid #f0f0f0;
  margin-bottom: 12px;
}
.dropdown-options-modal .modal-content .options-list .options-header .header-col {
  font-size: 12px;
  font-weight: 600;
  color: #595959;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.dropdown-options-modal .modal-content .options-list .options-header .default-col {
  text-align: center;
}
.dropdown-options-modal .modal-content .options-list .option-row {
  display: grid;
  grid-template-columns: 1fr 1fr 60px 48px;
  gap: 12px;
  align-items: start;
  margin-bottom: 12px;
  padding: 12px;
  background: #fafafa;
  border-radius: 6px;
  border: 1px solid #f0f0f0;
  transition: all 0.2s ease;
}
.dropdown-options-modal .modal-content .options-list .option-row:hover {
  background: #f5f5f5;
  border-color: #d9d9d9;
}
.dropdown-options-modal .modal-content .options-list .option-row .form-item {
  margin-bottom: 0;
}
.dropdown-options-modal .modal-content .options-list .option-row .value-col {
  grid-column: 1;
}
.dropdown-options-modal .modal-content .options-list .option-row .label-col {
  grid-column: 2;
}
.dropdown-options-modal .modal-content .options-list .option-row .default-col {
  grid-column: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 8px;
}
.dropdown-options-modal .modal-content .options-list .option-row .actions-col {
  grid-column: 4;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 4px;
}
.dropdown-options-modal .modal-content .options-list .option-row .actions-col button {
  display: flex;
  align-items: center;
  justify-content: center;
}
.dropdown-options-modal .modal-content .add-option-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  font-weight: 500;
}
.dropdown-options-modal .modal-content .add-option-btn:hover {
  border-color: #40a9ff;
  color: #40a9ff;
}
.dropdown-options-modal .modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}
@media (max-width: 768px) {
  .dropdown-options-modal .options-list .options-header,
  .dropdown-options-modal .options-list .option-row {
    grid-template-columns: 1fr;
  }
  .dropdown-options-modal .options-list .options-header .header-col,
  .dropdown-options-modal .options-list .options-header .form-item,
  .dropdown-options-modal .options-list .options-header .default-col,
  .dropdown-options-modal .options-list .options-header .actions-col,
  .dropdown-options-modal .options-list .option-row .header-col,
  .dropdown-options-modal .options-list .option-row .form-item,
  .dropdown-options-modal .options-list .option-row .default-col,
  .dropdown-options-modal .options-list .option-row .actions-col {
    grid-column: 1;
  }
  .dropdown-options-modal .options-list .options-header .default-col,
  .dropdown-options-modal .options-list .options-header .actions-col,
  .dropdown-options-modal .options-list .option-row .default-col,
  .dropdown-options-modal .options-list .option-row .actions-col {
    justify-content: flex-start;
  }
  .dropdown-options-modal .options-list .options-header .actions-col {
    display: none;
  }
}
/*# sourceMappingURL=dropdown-options-modal.component.css.map */
